import qs from "qs";
import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
import helper from "../transaction/transactionHelper";
export default {
  login(message) {
    return API.peakAPI
      .post("/api/Authentication/Login", message)
      .then((res) => {
        return {
          resCode: res.data.responseCode,
          merchantlist: res.data.logIn.merchantList,
          userModel: res.data.logIn.user,
        };
      })
      .catch((err) => err);
  },
  DoGetAccessToken(userName, password, userType = 0, source = Enums.ActivityLogSource.None, iss) {
    const data = qs.stringify({
      grant_type: "password",
      client_id: "account",
      client_secret: "accountSecret",
      scope: "account.api.full offline_access openid",
      username: userName,
      password: password,
      user_type: userType,
      token: "",
      source: source,
      iss: iss,
    });
    return API.peakAuthenticationAPI
      .post("/connect/token", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          ApplicationId: Enums.AuthenticationApplication.PeakExperience,
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoGetNewAccessTokenByRefreshToken() {
    const data = qs.stringify({
      grant_type: "refresh_token",
      client_id: "account",
      client_secret: "accountSecret",
      refresh_token: userInfo.GetRefreshToken(),
    });

    return API.peakAuthenticationAPI
      .post("/connect/token", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          ApplicationId: Enums.AuthenticationApplication.PeakExperience,
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoGetRefreshTokenExpiration() {
    let refreshToken = userInfo.GetRefreshToken();
    if (refreshToken) {
      refreshToken = JSON.stringify(refreshToken);
    }
    return API.peakAuthenticationAPI
      .post("/token/GetRefreshTokenExpiration", refreshToken, {
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoClearToken(userId) {
    const tokenInfo = {
      userId: userId,
      clientId: "account",
    };
    return API.peakAuthenticationAPI
      .post("/token/ClearToken", tokenInfo, {
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoClearAllToken(token) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { x: token.x };

    return API.peakAuthenticationAPI.get("/token/ClearAllToken", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetUserInfoByUserId() {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};
    return API.peakRealTimeAPIForUser.get("/api/User/GetUserInfoByUserId", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetRecommendForUser() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI.post("/api/Merchant/GetRecommend", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoRefreshMerchantList() {
    return API.peakAuthenticationAPI
      .post("/connect/userinfo", "", {
        headers: {
          Authorization: `Bearer ${userInfo.GetAccessToken()}`,
        },
      })
      .then((res) => {
        return res;
      });
  },
  DoSetForgotPwd(userName) {
    let input = {
      userName: userName,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/User/SetForgotPwd", input, userInfo.SetHeaderService())
      .then((res) => {
        return {
          responseCode: res.data.responseCode,
        };
      })
      .catch((err) => err);
  },
  DoGetForgotPwd(_input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { ..._input };

    return API.peakRealTimeAPI
      .get("/api/User/GetForgotPwd", { params, headers })
      .then((res) => {
        return res;
      })
      .catch((err) => err);
  },
  DoResetPwd(_input) {
    return API.peakRealTimeAPIForTransaction
      .post("/api/User/ResetPwd", _input)
      .then((res) => {
        return res;
      })
      .catch((err) => err);
  },
  DoGetUserDetailForDisplay(userIdList) {
    return API.peakAPI
      .post(
        "/api/User/GetUserDetailListForDisplay",
        {
          merchantId: userInfo.MerchantId(),
          userIdList: userIdList,
        },
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoGetAllUserDetailListForDisplayByMerchantId() {
    return API.peakAPI
      .post(
        "/api/User/GetAllUserDetailListForDisplayByMerchantId",
        {
          merchantId: userInfo.MerchantId(),
        },
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoRegister(_input) {
    let input = {
      userProfileModel: _input,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/User/Register", input)
      .then((res) => {
        return {
          res: res.data,
        };
      })
      .catch((err) => err);
  },
  DoRevokeRefreshToken() {
    let refreshToken = userInfo.GetRefreshToken();
    if (refreshToken) {
      const data = qs.stringify({
        client_id: "account",
        client_secret: "accountSecret",
        token: userInfo.GetRefreshToken(),
        token_type_hint: "refresh_token",
      });
      return API.peakAuthenticationAPI
        .post("/connect/revocation", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => err.response);
    }
  },
  DoRevokeAccessToken() {
    let accessToken = userInfo.GetAccessToken();
    if (accessToken) {
      const data = qs.stringify({
        client_id: "account",
        client_secret: "accountSecret",
        token: userInfo.GetAccessToken(),
        token_type_hint: "access_token",
      });
      return API.peakAuthenticationAPI
        .post("/connect/revocation", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => err.response);
    }
  },
  DoRevokeToken(idToken, userId) {
    const data = qs.stringify({});
    return API.peakAuthenticationAPI
      .get("/connect/endsession?id_token_hint=" + idToken + "&eui=" + userId, data)
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoAddNewUser(userRoleDetail) {
    let input = {
      merchantId: userInfo.MerchantId(),
      userRoleDetail: userRoleDetail,
      invitationType: Enums.InvitationType.InviteUserToMerchant,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/User/AddNewUser", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRemoveUser(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      fromMerchantId: _input.fromMerchantId,
      removeUserId: _input.userId,
    };
    return API.peakRealTimeAPI.post("/api/User/RemoveUser", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoRemoveUserV2(_input) {
    let input = {
      removeUserId: _input.userId,
    };
    return API.peakRealTimeAPI.post("/api/v2/User/RemoveUser", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCancelInvitation(_input) {
    return API.peakRealTimeAPI.post("/api/User/CancelInvitation", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateUserProfile(userTemplate) {
    const formData = new FormData();
    const userTemplateData = {
      ...userTemplate,
    };
    delete userTemplateData.pictureImg;
    delete userTemplateData.signatureImg;
    formData.append("merchantId", userInfo.MerchantId());
    if (userTemplate.pictureImg.rawString.startsWith("data:")) {
      const blobPictureImg = helper.Base64ToBlob(userTemplate.pictureImg.rawString, userTemplate.pictureImg.fileType);
      formData.append(`pictureImg`, blobPictureImg, userTemplate.pictureImg.fileName);
    }
    if (userTemplate.signatureImg.rawString.startsWith("data:")) {
      const blobSignatureImg = helper.Base64ToBlob(
        userTemplate.signatureImg.rawString,
        userTemplate.signatureImg.fileType
      );
      formData.append(`signatureImg`, blobSignatureImg, userTemplate.signatureImg.fileName);
    }
    formData.append("userTemplate", JSON.stringify(userTemplateData));

    return API.peakRealTimeAPIForImport
      .post("/api/User/UpdateUserProfile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoChangePassword(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      password: _input.password,
      newPassword: _input.newPassword,
    };

    return API.peakRealTimeAPI.post("/api/User/ChangePassword", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateReferFriendStatusCaseCreateMerchant(input) {
    let _input = {
      merchantId: input.merchantId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/User/DoUpdateReferFriendStatusCaseCreateMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoAcceptInvitation(input) {
    return API.peakRealTimeAPIForTransaction
      .post("/api/User/AcceptInvitation", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoAcceptInvitationV2(input) {
    return API.peakRealTimeAPIForTransaction
      .post("/api/v2/User/AcceptInvitation", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvitationInRole(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { ...input };
    return API.peakAPI.get("/api/User/GetInvitationInRole", { params, headers }).then((res) => {
      return res;
    });
  },
  DoInsertUserProfileConsent(input) {
    let _input = {
      userId: input.userId,
      isConsentTerm: input.isConsentTerm,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/User/InsertUserProfileConsent", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetUserProfileConsent(userId) {
    let _input = {
      userId: userId,
    };
    return API.peakRealTimeAPI
      .post("/api/User/GetUserProfileConsent", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGet2ndLogin() {
    return API.peakAPI.post("/api/User/Get2ndLogin", {}, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoSet2ndLogin() {
    return API.peakAPI.post("/api/User/Set2ndLogin", {}, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetUserInAppPEAK(input) {
    let _input = {
      merchantId: input.merchantId,
      userId: input.userId,
      inAppSuggestionTypes: input.inAppSuggestionTypes,
      joinMerchantDateTime: input.joinMerchantDateTime,
      merchantCreateDateTime: input.merchantCreateDateTime,
    };
    return API.peakAPI.post("/api/User/GetUserInAppPEAK", _input, userInfo.SetHeaderService()).then((res) => {
      return res.data;
    });
  },
  DoUpdateUserInAppPEAK(input) {
    let dateTimeNow = new Date();
    let _input = {
      merchantId: input.merchantId,
      userId: input.userId,
      inAppSuggestionData: {
        merchantId: input.merchantId,
        userId: input.userId,
        inAppType: input.inAppType,
        inAppValue: true,
        createdDateTime: dateTimeNow,
        updatedDateTime: dateTimeNow,
      },
    };
    return API.peakAPI.post("/api/User/UpdateUserInAppPEAK", _input, userInfo.SetHeaderService()).then((res) => {
      return res.data;
    });
  },
  DoSendVideoFeedback(input) {
    return API.peakAPI
      .post("/api/User/UserFeedbackVideo", input, userInfo.SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err) => userInfo.CatchAPIService(err.response));
  },
  DoGetVideoFeedback(input) {
    return API.peakAPI
      .post("/api/User/GetUserFeedbackVideo", input, userInfo.SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err) => userInfo.CatchAPIService(err.response));
  },
  DoIntrospectAccessToken() {
    const assetToken = userInfo.GetAccessToken();
    const data = qs.stringify({
      client_secret: "account.api.secret",
      client_id: "account.api",
      token: assetToken ? assetToken : "",
    });
    return API.peakAuthenticationAPI
      .post("/connect/introspect", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  },
  DoValidateUsername(username) {
    let _input = {
      username: username,
    };
    return API.peakRealTimeAPI.post("/api/User/ValidateUsername", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetSuperUserByMerchantId() {
    let _input = null;
    return API.peakRealTimeAPI
      .post("/api/User/GetSuperUserByMerchantId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateIsCanAcceptInvitation(input) {
    let _input = {
      invitationId: input.invitationId,
      invitationCode: input.invitationCode,
    };
    return API.peakRealTimeAPI
      .post("/api/User/ValidateIsCanAcceptInvitation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetUserSenderInvitationDetail(input) {
    let _input = {
      invitationId: input.invitationId,
      invitationCode: input.invitationCode,
    };
    return API.peakRealTimeAPI
      .post("/api/User/GetUserSenderInvitationDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSendEmailVerification(input) {
    return API.peakRealTimeAPI
      .post("/api/User/SendEmailVerification", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoResendEmailVerification(input) {
    return API.peakRealTimeAPI
      .post("/api/User/ResendEmailVerification", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetVerifyEmail(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { ...input };

    return API.peakRealTimeAPI.get("/api/User/VerifyEmail", { params, headers }).then((res) => {
      return res;
    });
  },
  DoUpdatePeakMission(input) {
    return API.peakRealTimeAPI
      .post("/api/merchant/UpdatePeakMission", input, userInfo.SetHeaderService())
      .then((res) => {
        return res.data;
      });
  },
  DoGetPeakGuide() {
    const headers = userInfo.SetHeaderService().headers;
    return API.peakRealTimeAPI.get("/api/merchant/GetPeakGuide", { headers }).then((res) => {
      return res;
    });
  },
};
